module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/hd-mengjianli.b069ff4f.jpg";